import React, { Component } from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import classNames from 'classnames';
import LinkButton from '../LinkButton';
import { getTextColorsFromSection } from '../lib/colors';
import Section from '../Section';
import TypographyDraft from '../TypographyDraft';
import MapBox from './MapBox';
import getSectionBackgroundStyle from '../lib/getSectionBackgroundStyle';

class LocationSection extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    event: PropTypes.object.isRequired,
    site: PropTypes.object.isRequired,
    section: PropTypes.object.isRequired,
  };

  render() {
    const { classes, section, site, event } = this.props;
    const { title, buttons, address, removeBackgroundImageOnMobile } = section.data;
    const { title: titleStyles, address: addressStyles, buttons: buttonsStyle } = section.styles;

    const button = buttons && buttons[0];
    const buttonStyle = buttonsStyle && buttonsStyle[0];
    const colors = getTextColorsFromSection(site, section);

    const { lat, lng } = event.address.location;

    return (
      <Section site={site} section={section} className={classes.root} withBackground={false}>
        <div className={classes.mapWrapper}>
          <MapBox latitude={lat} longitude={lng} zoom={16} />
        </div>
        <div
          className={classNames(
            classes.locationInfo,
            classes.backgroundOverlay,
            removeBackgroundImageOnMobile && classes.hideOnMobile,
          )}
          style={getSectionBackgroundStyle(section)}
        >
          <TypographyDraft
            component="h2"
            style={{ ...colors.title, ...titleStyles }}
            data={title}
          />

          <TypographyDraft
            className={classes.address}
            style={{ ...colors.text, ...addressStyles }}
            data={address}
          />

          {button && (
            <LinkButton
              button={{
                ...button,
                url: `https://www.google.com/maps/place/${event.address.location.lat}%2C${
                  event.address.location.lng
                }`,
              }}
              className={classes.button}
              style={buttonStyle}
              event={event}
              site={site}
              section={section}
            >
              {button.title}
            </LinkButton>
          )}
        </div>
      </Section>
    );
  }
}

const stylesheet = theme => ({
  root: {
    display: 'flex',
    boxSizing: 'border-box',
    width: '100%',
    height: 400,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      height: '100%',
    },
  },
  mapWrapper: {
    width: '100%',
    height: 200,
    backgroundColor: 'white',
    [theme.breakpoints.up('sm')]: {
      width: '40%',
      height: '100%',
    },
    [theme.breakpoints.up('lg')]: {
      width: `calc((100vw - ${theme.breakpoints.values.lg}px) / 2 + 40%)`,
      marginLeft: `calc((${theme.breakpoints.values.lg}px - 100vw) / 2)`,
    },
  },
  locationInfo: {
    flex: 1,
    backgroundPosition: 'center',
    padding: [theme.spacing.xlarge, theme.spacing.large],
    [theme.breakpoints.down('sm')]: {
      padding: [theme.spacing.large, theme.spacing.medium],
    },
    [theme.breakpoints.up('lg')]: {
      width: `calc((100vw + ${theme.breakpoints.values.lg}px) / 2 + 60%)`,
      marginRight: `calc((${theme.breakpoints.values.lg}px - 100vw) / 2)`,
    },
    '& *': {
      position: 'relative',
    },
  },
  address: {
    margin: [[4 * theme.spacing.unit, 0]],
  },
  button: {
    margin: 0,
  },
  backgroundOverlay: {
    position: 'relative',
    '&::before': {
      backgroundColor: ({ section: { styles } }) => styles.backgroundColor,
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      content: '" "',
    },
  },
  hideOnMobile: {
    [theme.breakpoints.down('sm')]: {
      backgroundImage: 'none !important',
    },
  },
});

export default injectSheet(stylesheet)(LocationSection);



// WEBPACK FOOTER //
// ./src/site-render/src/LocationSection/LocationSection.js